import styles from "./styles.module.scss";
import FilterInTable from "../../../../Manage/FilterInTable";
import { AiOutlineDislike, AiOutlineLike } from "react-icons/ai";
import { FaStar } from "react-icons/fa";
import SatisfactionLevel from "../../../../../assets/images/satisfaction-level.png";
import DatatableComponent from "../../../../../components/common/DatatableComponent/DatatableComponent";

const SellerReviews = () => {
  const data = [
    {
      reviewId: "001",
      customer: { customerName: "William John", date: "30 March 2024", likes: 11, dislikes: 0 },
      satisfactionLevel: "Satisfied",
      review: `Impressive product! This product exceeded my expectations. It's well-made and functions perfectly.`,
      rating: 5,
      status: "Not replied",
    },
    {
      reviewId: "001",
      customer: { customerName: "William John", date: "30 March 2024", likes: 11, dislikes: 0 },
      satisfactionLevel: "Satisfied",
      review: `Impressive product! This product exceeded my expectations. It's well-made and functions perfectly.`,
      rating: 5,
      status: "Not replied",
    },
    {
      reviewId: "001",
      customer: { customerName: "William John", date: "30 March 2024", likes: 11, dislikes: 0 },
      satisfactionLevel: "Satisfied",
      review: `Impressive product! This product exceeded my expectations. It's well-made and functions perfectly.`,
      rating: 5,
      status: "Not replied",
    },
    {
      reviewId: "001",
      customer: { customerName: "William John", date: "30 March 2024", likes: 11, dislikes: 0 },
      satisfactionLevel: "Satisfied",
      review: `Impressive product! This product exceeded my expectations. It's well-made and functions perfectly.`,
      rating: 5,
      status: "Not replied",
    },
    {
      reviewId: "001",
      customer: { customerName: "William John", date: "30 March 2024", likes: 11, dislikes: 0 },
      satisfactionLevel: "Satisfied",
      review: `Impressive product! This product exceeded my expectations. It's well-made and functions perfectly.`,
      rating: 5,
      status: "Not replied",
    },
    {
      reviewId: "001",
      customer: { customerName: "William John", date: "30 March 2024", likes: 11, dislikes: 0 },
      satisfactionLevel: "Satisfied",
      review: `Impressive product! This product exceeded my expectations. It's well-made and functions perfectly.`,
      rating: 5,
      status: "Not replied",
    },
    {
      reviewId: "001",
      customer: { customerName: "William John", date: "30 March 2024", likes: 11, dislikes: 0 },
      satisfactionLevel: "Satisfied",
      review: `Impressive product! This product exceeded my expectations. It's well-made and functions perfectly.`,
      rating: 5,
      status: "Not replied",
    },
    {
      reviewId: "001",
      customer: { customerName: "William John", date: "30 March 2024", likes: 11, dislikes: 0 },
      satisfactionLevel: "Satisfied",
      review: `Impressive product! This product exceeded my expectations. It's well-made and functions perfectly.`,
      rating: 5,
      status: "Not replied",
    },
  ];

  const columns = [
    {
      name: "Review ID",
      selector: (row) => row.reviewId,
      sortable: true,
      wrap: true,
      minWidth: "140px",
    },
    {
      name: "Customer Name",
      cell: (row) => (
        <div>
          <div className="d-flex gap-2">{row.customer.customerName}</div>
          <div className="d-flex gap-3 mt-2">
            <div>{row.customer.date}</div>
            <div className="d-flex gap-2">
              <div className="d-flex">
                <div>{row.customer.likes}</div>
                <div className="d-flex align-items-center">
                  <AiOutlineLike />
                </div>
              </div>
              <div className="d-flex">
                <div>{row.customer.dislikes}</div>
                <div className="d-flex align-items-center">
                  <AiOutlineDislike />
                </div>
              </div>
            </div>
          </div>
        </div>
      ),
      sortable: true,
      grow: 1,
      wrap: true,
      minWidth: "220px",
    },
    {
      name: "Satisfaction Level",
      cell: (row) => (
        <div className="d-flex gap-2 align-items-center">
          <div>
            <img src={SatisfactionLevel} alt="" />
          </div>
          <div>{row.satisfactionLevel}</div>
        </div>
      ),
      sortable: true,
      grow: 1,
      minWidth: "200px",
    },
    {
      name: "Review",
      selector: (row) => row.review,
      sortable: true,
      wrap: true,
      grow: 2,
      minWidth: "220px",
    },
    {
      name: "Rating",
      cell: (row) => (
        <div className={styles["star"]}>
          {Array.from({ length: row.rating }, (v, i) => (
            <FaStar key={i} />
          ))}
        </div>
      ),
      sortable: true,
      grow: 1,
      minWidth: "120px",
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      grow: 1,
      minWidth: "120px",
    },
    {
      name: "Actions",
      cell: (row) => (
        <div>
          <div>
            <button
              onClick={() => handleReply(row.reviewId)}
              className={styles["button"]}
            >
              Reply
            </button>
          </div>
          <div>
            <button
              onClick={() => handleReport(row.reviewId)}
              className={styles["button"]}
            >
              Report
            </button>
          </div>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      grow: 1,
      minWidth: "120px",
    },
  ];

  return (
    <div className={`p-3 ${styles["outer-wrapper"]}`}>
      <FilterInTable componentName="Customer Engage Seller Reviews" />
      <div className="my-3">
        <DatatableComponent
          data={data}
          columns={columns}
          type={"yellow"}
          pagination
        />
      </div>
    </div>
  );
};

export default SellerReviews;